import {
  SEARCH_RESIDENT_GROUP,
  SEARCH_RESIDENT_GROUP_SUCCESS,
  SEARCH_RESIDENT_GROUP_FAILURE,
  FETCH_RESIDENT_GROUP,
  FETCH_RESIDENT_GROUP_SUCCESS,
  FETCH_RESIDENT_GROUP_FAILURE,
  ADD_RESIDENT_GROUP,
  ADD_RESIDENT_GROUP_SUCCESS,
  ADD_RESIDENT_GROUP_FAILURE,
  FETCH_RESIDENT_GROUP_ITEM,
  FETCH_RESIDENT_GROUP_ITEM_SUCCESS,
  FETCH_RESIDENT_GROUP_ITEM_FAILURE,
  EDIT_RESIDENT_GROUP,
  EDIT_RESIDENT_GROUP_SUCCESS,
  EDIT_RESIDENT_GROUP_FAILURE,
  DELETE_RESIDENT_GROUP,
  DELETE_RESIDENT_GROUP_SUCCESS,
  DELETE_RESIDENT_GROUP_FAILURE,
  SET_RESIDENT_GROUP_ADD_EDIT_MODAL,
} from "./constants";

export const searchResidentGroup = (payload) => ({
  type: SEARCH_RESIDENT_GROUP,
  payload,
});
export const searchResidentGroupSuccess = (payload) => ({
  type: SEARCH_RESIDENT_GROUP_SUCCESS,
  payload,
});
export const searchResidentGroupFailure = (payload) => ({
  type: SEARCH_RESIDENT_GROUP_FAILURE,
  payload,
});

export const fetchResidentGroup = (payload) => ({
  type: FETCH_RESIDENT_GROUP,
  payload,
});
export const fetchResidentGroupSuccess = (payload) => ({
  type: FETCH_RESIDENT_GROUP_SUCCESS,
  payload,
});
export const fetchResidentGroupFailure = (payload) => ({
  type: FETCH_RESIDENT_GROUP_FAILURE,
  payload,
});

export const addResidentGroup = (payload) => ({
  type: ADD_RESIDENT_GROUP,
  payload,
});
export const addResidentGroupSuccess = (payload) => ({
  type: ADD_RESIDENT_GROUP_SUCCESS,
  payload,
});
export const addResidentGroupFailure = (payload) => ({
  type: ADD_RESIDENT_GROUP_FAILURE,
  payload,
});

export const fetchResidentGroupItem = (payload) => ({
  type: FETCH_RESIDENT_GROUP_ITEM,
  payload,
});
export const fetchResidentGroupItemSuccess = (payload) => ({
  type: FETCH_RESIDENT_GROUP_ITEM_SUCCESS,
  payload,
});
export const fetchResidentGroupItemFailure = (payload) => ({
  type: FETCH_RESIDENT_GROUP_ITEM_FAILURE,
  payload,
});

export const editResidentGroup = (payload) => ({
  type: EDIT_RESIDENT_GROUP,
  payload,
});
export const editResidentGroupSuccess = (payload) => ({
  type: EDIT_RESIDENT_GROUP_SUCCESS,
  payload,
});
export const editResidentGroupFailure = (payload) => ({
  type: EDIT_RESIDENT_GROUP_FAILURE,
  payload,
});

export const deleteResidentGroup = (payload, onDelete) => ({
  type: DELETE_RESIDENT_GROUP,
  payload,
  onDelete,
});
export const deleteResidentGroupSuccess = (payload) => ({
  type: DELETE_RESIDENT_GROUP_SUCCESS,
  payload,
});
export const deleteResidentGroupFailure = (payload) => ({
  type: DELETE_RESIDENT_GROUP_FAILURE,
  payload,
});

export const setResidentGroupAddEditModal = (payload) => ({
  type: SET_RESIDENT_GROUP_ADD_EDIT_MODAL,
  payload,
});
